import { render, staticRenderFns } from "./quanLiuCheng.vue?vue&type=template&id=70b4ca96&scoped=true&"
import script from "./quanLiuCheng.vue?vue&type=script&lang=js&"
export * from "./quanLiuCheng.vue?vue&type=script&lang=js&"
import style0 from "./quanLiuCheng.vue?vue&type=style&index=0&id=70b4ca96&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b4ca96",
  null
  
)

export default component.exports